import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { loadI18nResource } from "../i18n";

export function useI18nReady() {
  const { i18n } = useTranslation();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(false);
    loadI18nResource(i18n.language).then(() => setReady(true));
    // Nếu loadI18nResource đã cache đúng version thì sẽ resolve rất nhanh
  }, [i18n.language]);

  return ready;
}
